var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaderDerek)?_c('loading-derek'):_vm._e(),_c(_vm.menuLayoutDerek,{tag:"component"}),_c('main',{staticClass:"base-container",style:(_vm.footerLayoutDerek == 'footer-simple'
        ? 'min-height: calc(100vh - 142px); '
        : 'margin-top: 0')},[_c('router-view')],1),_c('modal-login'),_c('modal-register'),_c('modal-news-latter-done'),_c('modal-cupo'),_c('modal-sold-out'),_c(_vm.footerLayoutDerek,{tag:"component"}),_c('Modal-utm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }